import React, { useState, useEffect } from 'react';

export const SidebarRotator = ({ images, type = 'club', visibleCount = 3, className = "" }) => { // type: 'club' or 'sponsor'
    const [startIndex, setStartIndex] = useState(0);
    const VISIBLE_COUNT = visibleCount;
    const ROTATION_SPEED = 4000; // ms

    useEffect(() => {
        if (!images || images.length <= VISIBLE_COUNT) return;

        const interval = setInterval(() => {
            setStartIndex((current) => (current + 1) % images.length);
        }, ROTATION_SPEED);

        return () => clearInterval(interval);
    }, [JSON.stringify(images), VISIBLE_COUNT]);

    if (!images || images.length === 0) return null;

    // Als er minder images zijn dan de zichtbare ruimte, toon ze gewoon statisch
    if (images.length <= VISIBLE_COUNT) {
        return (
            <div className={`flex flex-col gap-4 animate-fade-in ${className}`}>
                {images.map((img, idx) => (
                    <img
                        key={idx}
                        src={img}
                        alt={`${type} banner`}
                        className="w-full h-auto rounded-xl shadow-lg border border-white/20 hover:scale-105 transition-transform duration-500 bg-white p-2 object-contain"
                        onError={(e) => e.target.style.display = 'none'}
                    />
                ))}
            </div>
        );
    }

    // Rotatie Logica
    const visibleItems = [];
    for (let i = 0; i < VISIBLE_COUNT; i++) {
        const index = (startIndex + i) % images.length;
        visibleItems.push(images[index]);
    }

    return (
        <div className={`flex flex-col gap-4 ${className}`}>
            {visibleItems.map((img, idx) => (
                <div key={`${startIndex}-${idx}`} className="animate-fade-in w-full flex justify-center">
                    <img
                        src={img}
                        alt={`${type} banner rotatie`}
                        className="w-full h-auto rounded-xl shadow-lg border border-white/20 object-contain transition-all duration-700 hover:scale-105 bg-white p-2"
                        onError={(e) => e.target.style.display = 'none'}
                    />
                </div>
            ))}

            {/* Indicator Dots */}
            <div className="flex justify-center gap-1 mt-2">
                {images.map((_, idx) => (
                    <div
                        key={idx}
                        className={`w-1.5 h-1.5 rounded-full transition-colors ${idx === startIndex ? 'bg-white' : 'bg-white/20'
                            }`}
                    />
                ))}
            </div>
        </div>
    );
};
